import * as types from './constants';
import initialState from '../../reducers/initialState';

function updateState(state){
    return state;
}

export default function timeSheetReducer(state = initialState.timeSheets, action) {
    switch (action.type) {
        case types.LOAD_TIMESHEET_SUCCESS:
            return action.timeSheets;

        case types.UPDATE_TIMESHEET_SUCCESS:
            state = updateState(state);
            return state;

        case types.CREATE_TIMESHEET_SUCCESS:
            return state;

        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/reducers.js
 **/